import { NavLink } from "react-router-dom";

const TopButton = ({ to, icon, label }) => {
    return (
        <NavLink
            to={to}
            className={({ isActive }) =>
                `top-buttons ${isActive ? "active" : ""}`
            }
        >
            {icon}
            <span>{label}</span>
        </NavLink>
    );
};

export default TopButton;
